import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify, {
    options: {
        customProperties: true
    }
})

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: '#ff6347', // orange
                secondary: '#1AA2E8', // soft blue
                accent: '#e91e63', // pink
                error: '#f44336', // red
                warning: '#ff5722', // deep-orange
                info: '#03a9f4', // light-blue
                success: '#8bc34a' // light-green
            }
        }
    },
    icons: {
        iconfont: 'md'
    }
})
